import { render, staticRenderFns } from "./GameZL.vue?vue&type=template&id=e967fe4e&scoped=true"
import script from "./GameZL.vue?vue&type=script&lang=js"
export * from "./GameZL.vue?vue&type=script&lang=js"
import style0 from "./GameZL.vue?vue&type=style&index=0&id=e967fe4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e967fe4e",
  null
  
)

export default component.exports